export const CATEGORIES = [
  'Grünpflanzen',
  'Beet- und Balkonpflanzen',
  'Topf- und Kübelpflanzen',
  'Gemüsekulturen',
  'Kräuterkulturen',
  'Farne',
  'Gräser',
  'Wasser und Sumpfpflanzen',
] as const;

export type Category = typeof CATEGORIES[number];
